export const languages = ["eng", "srb"];

/** Short labels shown in the UI (i18n keys stay eng / srb). */
export const languageLabels = {
  eng: "EN",
  srb: "SR",
};

export const navbarItems = [
  { id: 1, label: "home" },
  { id: 2, label: "speakers" },
  { id: 3, label: "schedule" },
  { id: 4, label: "locations" },
  { id: 5, label: "price" },
  { id: 6, label: "contact" },
];
